import { AppRoute } from './enums'

export const pageTitles: Record<AppRoute, string> = {
  [AppRoute.Homepage]: 'Dashboard - Brighterly',
  [AppRoute.Login]: 'Login - Brighterly',

  [AppRoute.TutorKanbanOnboarding]: 'Onboarding - Brighterly',
  [AppRoute.TutorKanbanActive]: 'Active - Brighterly',
  [AppRoute.TutorKanbanProbation]: 'Probation - Brighterly',
  [AppRoute.TutorKanbanInfo]: 'Info - Brighterly',
  [AppRoute.TutorKanbanComments]: 'Comments - Brighterly',
  [AppRoute.TutorKanbanLog]: 'Log - Brighterly',

  [AppRoute.TasksKanbanSupport]: 'Support - Brighterly',
  [AppRoute.TasksKanbanSuccess]: 'Success - Brighterly',
  [AppRoute.TasksKanbanBilling]: 'Billing - Brighterly',
  [AppRoute.TasksKanbanCreation]: 'Creation - Brighterly',
  [AppRoute.TasksKanbanLog]: 'Log - Brighterly',
  [AppRoute.TasksKanbanInfo]: 'Info - Brighterly',

  [AppRoute.TutorsLegal]: 'Legal - Brighterly',
  [AppRoute.TutorsPaymentPolicy]: 'Payment policy - Brighterly',
  [AppRoute.BillingTutorInfo]: 'Tutor billing info - Brighterly',

  [AppRoute.Customers]: 'Customers - Brighterly',
  [AppRoute.CustomersShow]: 'Customers - Brighterly',
  [AppRoute.CustomersDetails]: 'Details - Brighterly',
  [AppRoute.CustomersStatusesAndSources]: 'Statuses and sources - Brighterly',
  [AppRoute.CustomersComments]: 'Customer Comments - Brighterly',
  [AppRoute.CustomersSubscriptions]: 'Subscriptions - Brighterly',
  [AppRoute.CustomersOrders]: 'Orders - Brighterly',
  [AppRoute.CustomersCredits]: 'Credits - Brighterly',
  [AppRoute.CustomersChangelog]: 'Customer changelog - Brighterly',
  [AppRoute.CustomersTaskComments]: 'Task comments - Brighterly',
  [AppRoute.DisciplinesGeneralInfo]: 'Discipline - Brighterly',
  [AppRoute.DisciplinesBalances]: 'Balance - Brighterly',
  [AppRoute.DisciplinesTasks]: 'Tasks - Brighterly',
  [AppRoute.DisciplinesFiles]: 'Files - Brighterly',
  [AppRoute.DisciplinesReport]: 'Demo lesson report - Brighterly',
  [AppRoute.DisciplinesStageLogs]: 'Kanban log - Brighterly',
  [AppRoute.DisciplinesComments]: 'Comments - Brighterly',
  [AppRoute.DisciplinesChangelog]: 'Discipline changelog - Brighterly',
  [AppRoute.DisciplinesSurveys]: 'Discipline survey - Brighterly',
  [AppRoute.DisciplinesActivation]: 'Discipline activation - Brighterly',
  [AppRoute.DisciplinesProgressReports]: 'Discipline progress reports - Brighterly',
  [AppRoute.DisciplinesOrdersCreate]: 'Orders - Brighterly',
  [AppRoute.DisciplinesTaskComments]: 'Task comments - Brighterly',
  [AppRoute.KidsShow]: 'Kids - Brighterly',
  [AppRoute.KidsChangelog]: 'Kid changelog - Brighterly',

  [AppRoute.TutorKanbanTimeOffs]: 'Time offs - Brighterly',
  [AppRoute.DemosExtraRates]: 'Extra Rates - Brighterly',
  [AppRoute.DemosSlotsTracker]: 'Slots tracker - Brighterly',
  [AppRoute.DemosTutorSlotLog]: 'Tutor slot log - Brighterly',
  [AppRoute.DemosSlotsManagement]: 'Slots management - Brighterly',
  [AppRoute.DemosSlotsManagementSalesQueue]: 'Slots management: Sales queue - Brighterly',

  [AppRoute.ApiTokens]: 'API Tokens - Brighterly',
  [AppRoute.Promocodes]: 'Promo codes - Brighterly',
  [AppRoute.Orders]: 'Orders - Brighterly',
  [AppRoute.OrdersShow]: 'Order - Brighterly',
  [AppRoute.OrdersInvoice]: 'Customise invoice - Brighterly',
  [AppRoute.Subscriptions]: 'Subscriptions - Brighterly',
  [AppRoute.SubscriptionsChangelog]: 'Subscription changelog - Brighterly',
  [AppRoute.Surveys]: 'Surveys - Brighterly',
  [AppRoute.TutorAttendanceRates]: 'Tutor attendance rates - Brighterly',
  [AppRoute.Users]: 'Users & teams - Brighterly',
  [AppRoute.UserEdit]: 'User - Brighterly',
  [AppRoute.Teams]: 'Teams - Brighterly',
  [AppRoute.TeamEdit]: 'Team - Brighterly',

  [AppRoute.Settings]: 'Settings - Brighterly',
  [AppRoute.SettingsExperiments]: 'Experiments - Brighterly',

  [AppRoute.Helpers]: 'Helpers - Brighterly',
  [AppRoute.HelpersSales]: 'Helpers: Sales & SQA - Brighterly',
  [AppRoute.HelpersTutors]: 'Helpers: Tutors - Brighterly',
  [AppRoute.HelpersBookings]: 'Helpers: Bookings - Brighterly',
  [AppRoute.HelpersNewsletters]: 'Helpers: Newsletters - Brighterly',
  [AppRoute.HelpersSystem]: 'Helpers: Billing & System - Brighterly',

  [AppRoute.OAuth]: 'OAuth - Brighterly',

  [AppRoute.ImportSalesTax]: 'Import SalesTax - Brighterly',
  [AppRoute.ImportCurriculum]: 'Import Curriculum - Brighterly',
  [AppRoute.ImportTutorPayments]: 'Import Tutor Payments - Brighterly',

  [AppRoute.Assessments]: 'Assessments - Brighterly',
  [AppRoute.AssessmentEdit]: 'Assessment - Brighterly',

  [AppRoute.Changelog]: 'Changelog - Brighterly',
  [AppRoute.Assignments]: 'Assignments - Brighterly',
  [AppRoute.AssignmentEdit]: 'Assignment - Brighterly',
  [AppRoute.Stories]: 'Stories - Brighterly',
  [AppRoute.StoryEdit]: 'Story - Brighterly',

  [AppRoute.DisciplinesLessons]: 'Lessons - Brighterly',
  [AppRoute.LessonsCreate]: 'New lesson - Brighterly',
  [AppRoute.LessonsEdit]: 'Lesson - Brighterly',
  [AppRoute.LessonsConnectionLog]: 'Lesson connection log - Brighterly',
  [AppRoute.BookingsChangelog]: 'Booking changelog - Brighterly',
}
